module.exports = __webpack_public_path__ + "img/building4.5cc4d38a.jpg";